module.exports = __webpack_public_path__ + "static/media/image.aedd001d.svg";